import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  Sanitizer,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from 'src/app/services/common/common.service';
import { MessageService } from 'src/app/services/message.service';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { environment } from 'src/environments/environment';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  imageUrl: any =
    'https://icon-library.com/images/generic-user-icon/generic-user-icon-9.jpg';
  currentUrl!: any;
  userName!: String;
  validRoute: any[] = [];
  sidebarMenu: any[] = [];
  userRole: any;
  profile: any;
  currentUrl1!: string;
  firstName: String = '';
  role: string = '';
  logoImg!: any;
  consultantLogo!: any;

  @Output() getToggleValue: EventEmitter<boolean> = new EventEmitter();
  isSidebarCollapsed: boolean = false;

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
    this.getToggleValue.emit(this.isSidebarCollapsed);
  }

  constructor(
    private changeDetector: ChangeDetectorRef,
    private commonService: CommonService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private messageService: MessageService,
    private _dialog: MatDialog,
    private organisationService: OrganizationSetupService
  ) {
    this.router.events.subscribe(val => {
      this.currentUrl1 = this.router?.url;
    });
  }

  ngOnInit(): void {
    this.commonService._logoImgPath.subscribe((res: any) => {
      this.logoImg = environment.apiHostName + '/' + res;
    });

    this.currentUrl = this.router.url;
    this.userName = JSON.parse(localStorage.getItem('userData')!).username;
    this.currentUrl = window.location.pathname;
    let image = localStorage.getItem('imageUrl');
    if (image && this.currentUrl != '/setup')
      this.imageUrl = localStorage.getItem('imageUrl');
    this.changeDetector.detectChanges();
    let userRole = JSON.parse(localStorage.getItem('userData')!)?.roleName;
    this.userRole =
      userRole == 'SuperAdmin' || userRole == 'Admin' ? userRole : 'user';

    this.firstName = JSON.parse(localStorage.getItem('userData')!).FirstName;
    this.role = JSON.parse(localStorage.getItem('userData')!)?.roleName;

    this.sidebarMenu = JSON.parse(localStorage.getItem('validRoutes')!);
    // if (this.userRole != 'user') {
    //   this.sidebarMenu = CommonService.superAdminMenu;
    // } else {
    this.sidebarMenu = this.commonService.userMenu;
    this.sidebarMenu?.forEach(menu => {
      if (menu.subMenu) {
        menu.subMenuVisible = menu.subMenu?.some(
          (subMenu: any) => subMenu.routerLink === this.currentUrl
        );
      }
    });
    // }

    if (JSON.parse(localStorage.getItem('userData')!).Photo) {
      this.profile =
        environment.apiHostName +
        '/' +
        JSON.parse(localStorage.getItem('userData')!).Photo;
    }

    this.GetConfigurationValue();
  }

  GetConfigurationValue() {
    if (!this.consultantLogo) {
      this.commonService
        .GetConfigurationValue({ name: 'ConsultantLogoName' })
        .subscribe((res: any) => {
          let documentConfigData = JSON.parse(res?.data?.value);
          this.consultantLogo = documentConfigData?.LogoName
            ? '../../assets/images/' + documentConfigData?.LogoName
            : undefined;
        });
    }
  }

  isActive(menuLink: string) {
    if (
      this.currentUrl1 == '/environment/ghgSuite/GHG_Emission' &&
      menuLink == '/environment/ghgSuite/location_selection'
    )
      return true;
    else if (
      this.currentUrl1 == '/environment/ghgSuite/ghg-avoidance' &&
      menuLink == '/environment/ghgSuite/location-selection-Avoidance'
    )
      return true;
    else if (
      this.currentUrl1 == '/add_supplier' &&
      menuLink == '/supplier_assessment'
    )
      return true;
    else if (
      this.currentUrl1?.includes('/edit_supplier') &&
      menuLink == '/supplier_assessment'
    )
      return true;
    else if (
      this.currentUrl1?.includes('/environment/ghgSuite/offset-strategy/') &&
      menuLink == '/environment/ghgSuite/offset-strategy'
    )
      return true;
    else if (
      this.currentUrl1?.includes('/reports') &&
      menuLink == '/analysis-reporting'
    )
      return true;
    else if (
      this.currentUrl1?.includes('/detail-reports') &&
      menuLink == '/analysis-reporting'
    )
      return true;
    else if (
      this.currentUrl1?.includes('/iso-report') &&
      menuLink == '/analysis-reporting'
    )
      return true;
    else if (
      this.currentUrl1?.includes('/business-report') &&
      menuLink == '/analysis-reporting'
    )
      return true;
    else if (
      this.currentUrl1?.includes('/corporate-responsibility') &&
      menuLink == '/analysis-reporting'
    )
      return true;
    else if (
      this.currentUrl1?.includes('/csrd-report') &&
      menuLink == '/analysis-reporting'
    )
      return true;
    else if (
      this.currentUrl1?.includes('/office/create') &&
      menuLink == '/setup'
    )
      return true;
    else if (
      this.currentUrl1?.includes('/add-policy') &&
      menuLink == '/policies'
    )
      return true;
    else if (
      this.currentUrl1?.includes('/internal-benchmarking') &&
      menuLink == '/benchmarking'
    )
      return true;
    else if (
      this.currentUrl1?.includes('/environment/waste-location') &&
      menuLink == '/environment/waste-management'
    )
      return true;
    else if (
      this.currentUrl1?.includes('/environment/water-location') &&
      menuLink == '/environment/water-management'
    )
      return true;
    else if (
      this.currentUrl1?.includes('/environment/energy-location') &&
      menuLink == '/environment/energy-management'
    )
      return true;
    else if (
      this.currentUrl1?.includes('/environment/energy-management') &&
      menuLink == '/environment/energy-location'
    )
      return true;
    else if (
      this.currentUrl1 == '/social/employee-info' &&
      menuLink == '/social/employee-details'
    )
      return true;
    else if (
      this.currentUrl1 == '/governance/board-structure' &&
      menuLink == '/governance/board-location'
    )
      return true;
    else if (
      this.currentUrl1 == '/social/employee-information' &&
      menuLink == '/social/ohs'
    )
      return true;
    else if (
      this.currentUrl1 == '/social/dei-hr-information' &&
      menuLink == '/social/dei-hr-information'
    )
      return true;
    else if (
      this.currentUrl1?.includes('/add-product') &&
      menuLink == '/product-registry'
    )
      return true;
    else if (
      this.currentUrl1 ===
        '/governance/ethics-and-anti-corruption/add-details' &&
      menuLink === '/governance/ethics-and-anti-corruption'
    )
      return true;
    else if (
      this.currentUrl1 ===
        '/governance/risk-assessment-and-regulatory-compliance/add-details' &&
      menuLink === '/governance/risk-assessment-and-regulatory-compliance'
    )
      return true;

    return this.currentUrl1?.startsWith(menuLink);
  }

  logOut() {
    var dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      width: '23.472vw',
      data: {
        header: 'Logout ?',
        data: {
          bodyData: `Are you sure, you want to Logout ?`,
        },
        button: {
          isSubmit: true,
          submitbtnText: 'Logout',
          isCancel: true,
          isDelete: false,
        },
      },
    });
    dialogRef.disableClose = true;

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result == 'ok') {
        this.spinner.show();
        this.commonService.logout().subscribe((res: any) => {
          localStorage.clear();
          // this.router.navigate(['/login']);
          this.router.navigate(['/login']).then(() => {
            // window.location.reload(); // Forces a full page reload Disabled to avoid unnecessary reload after logout,
            // but the chatbot feature might require enabling it.
          });
          this.spinner.hide();
        });
      }
    });
  }

  routeChange(path: string) {
    if (this.organisationService.isEditing) {
      this.organisationService.routingPathBehaviourSubject.next(path);
    } else {
      this.router.navigate([path]);
    }
  }
}
